import dcc_ufmg from '../assets/Logo-DCC-UFMG-Fundo-Claro.png';
import mpmg from '../assets/mpmg.svg';
import gsi from '../assets/gsi.svg';
import { Paper, Container, Box, Typography, Divider } from '@mui/material';

type Props = {
    fixed?: boolean;
}

function Footer({ fixed }: Props) {
    return (<Paper sx={fixed ? {
        marginTop: 'calc(10% + 60px)',
        width: '100%',
        position: 'fixed',
        bottom: 0,
        border: 1
    } : {
        width: '100%',
    }} component="footer" square variant="outlined">
        <Container maxWidth="lg" >
            <Box
                sx={{
                    flexGrow: 1,
                    justifyContent: "center",
                    display: "flex",
                }}
            >


            </Box>

            <Box
                sx={{
                    flexGrow: 1,
                    justifyContent: "center",
                    display: "flex",
                    mb: 1,
                }}
                className="text-base font-normal opacity-75 flex justify-end items-center pr-4"
            >

                <p>Quanto Custa: v{process.env.REACT_APP_VERSION}</p>

            </Box>
        </Container>
    </Paper>);
}

export default Footer;
